import React, { useState } from "react";
import { ButtonSpinner, errorMessageHandler } from "../../../utils/utils";
import { useSelector, useDispatch } from "react-redux";
import MnemonicsConfirmationModal from "../../CreateNFT/SingleNFT/MnemonicsConfirmationModal";
import { setCypherSecret } from "../../../actions/auth";
import ContinueWithPassword from "../../CreateNFT/SingleNFT/ContinueWithPassword";
import CryptoJS from 'crypto-js';
import { cancelOrder, cancelOrderAPI } from "../../../api/nft/nft";
import MissingMnemonics from "../../Layouts/MissingMnemonics/MissingMnemonics";

const CancelOrder = ({ isOpen, onClose, id, onSuccess, nftDetailObject }) => {
   

    // 📦 Form state
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [passwordModal, setShowPasswordModal] = useState(false);
    const [mnemonicsConfirmationModal, setShowMnemonicsConfirmationModal] = useState(false);
    const dispatch = useDispatch();
    const currentUser = useSelector((state) => state.Profile.profile);
    const cypherSecret = useSelector((state) => state.Auth.cypherSecret);

    // Get order details
    const orderPrice = nftDetailObject?.openOrder?.price || 0;
    const orderId = nftDetailObject?.openOrder?._id;




    // 🚀 Handle confirmation (Yes button)
    const handleConfirm = async () => {
        // Check if user has NOT set up their wallet (public address)
        if (!currentUser.public_address) {
            return document.getElementById('confirmationMissingMnemonicsBtn').click();
        }

        // Show appropriate modal based on whether user has saved mnemonics
        if (cypherSecret) {
            setShowPasswordModal(true)
        }
        else {
            setShowMnemonicsConfirmationModal(true)
        }
    };

    const handleCancelOrder = (mnemonics, publicAddress, saveMyMnemonics, mnemonicsPwd) => {
        if (!mnemonics) {
            setErrors(prev => ({
                ...prev,
                submit: "Mnemonics are required to cancel the order."
            }));
            return;
        }

        if (!publicAddress) {
            setErrors(prev => ({
                ...prev,
                submit: "Your profile address does not match the provided mnemonics. Please use the mnemonics you provided during sign-up.",
            }));
            return;
        }

        if (publicAddress.toLowerCase() !== currentUser?.public_address?.toLowerCase()) {
            setErrors(prev => ({
                ...prev,
                submit: "Your profile address does not match the provided mnemonics. Please use the mnemonics you provided during sign-up.",
            }));
            return;
        }

        // ✅ All good — process order cancellation
        processCancelOrder(mnemonics, saveMyMnemonics, mnemonicsPwd);
    };

    let processCancelOrder = async (mnemonics, saveMyMnemonics, mnemonicsPwd) => {
        if (saveMyMnemonics) {
            const cypher = CryptoJS.AES.encrypt(mnemonics, mnemonicsPwd).toString();
            dispatch(setCypherSecret(cypher));
        }

        try {
            setIsLoading(true)
            setErrors({})
            let { data } = await cancelOrder({
                nftId: id,
                orderId: orderId,
                secret: mnemonics
            })
            setIsLoading(false)
            onSuccess && onSuccess(data.data.txHash)
            handleClose()
        } catch (error) {
            console.error("Cancel order error:", error);
            setErrors(prev => ({
                ...prev,
                submit: errorMessageHandler(error)
            }));
        } finally {
            setIsLoading(false);
        }
    }


    // 🔒 Handle modal close
    const handleClose = (result = false) => {
        setErrors({});
        setIsLoading(false);
        onClose();
    };

    if (!isOpen) return null;

    return (
        <>
           
            {/* Modal Backdrop */}
            <div
                className="modal-backdrop fade show"
                onClick={handleClose}
                style={{ zIndex: 1040 }}
            ></div>

            {/* Modal */}
            <div
                className="modal fade show"
                id="cancelOrderModalDesign"
                tabIndex="-1"
                aria-labelledby="cancelOrderModalDesignLabel"
                aria-modal="true"
                role="dialog"
                style={{ display: 'block', zIndex: 1050 }}
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content NFTDetailDesign__modal">
                        <div className="modal-header border-0 pb-0">
                            <h5 className="modal-title w-100 text-center fw-bold" id="cancelOrderModalDesignLabel">
                                Cancel Order
                            </h5>
                            <button type="button" className="btn-close" onClick={handleClose} aria-label="Close" />
                        </div>
                        <div className="modal-body text-center py-4">
                            {/* Warning Icon */}
                            <div className="mb-4">
                                <div
                                    className="d-inline-flex align-items-center justify-content-center rounded-circle"
                                    style={{
                                        width: '80px',
                                        height: '80px',
                                        background: 'linear-gradient(135deg, #fff5f5 0%, #ffe5e5 100%)',
                                        border: '3px solid #ffcccc'
                                    }}
                                >
                                    <i className="bi bi-exclamation-triangle-fill" style={{ fontSize: '2.5rem', color: '#dc3545' }}></i>
                                </div>
                            </div>

                            {/* Confirmation Message */}
                            <h5 className="mb-2 fw-bold">Cancel this listing?</h5>
                            <p className="text-muted mb-4">
                                This action will remove your NFT from the marketplace. You can always list it again later.
                            </p>

                            {/* Order Details Card */}
                            <div
                                className="rounded p-3 mb-3"
                                style={{
                                    background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                                    border: '1px solid #dee2e6'
                                }}
                            >
                                <p className="text-muted mb-2 small fw-semibold text-uppercase" style={{ letterSpacing: '0.5px' }}>
                                    Current Listing Price
                                </p>
                                <h3 className="mb-0 fw-bold" style={{ color: '#212529' }}>
                                    {orderPrice} <span className="text-muted fs-5">NUC</span>
                                </h3>
                            </div>

                            {/* ⚠️ Submit Error */}
                            {errors.submit && (
                                <div className="alert alert-danger text-start d-flex align-items-start" role="alert">
                                    <i className="bi bi-exclamation-triangle-fill me-2 mt-1" style={{ fontSize: '1.1rem' }}></i>
                                    <div>{errors.submit}</div>
                                </div>
                            )}
                        </div>
                        <div className="modal-footer border-0 justify-content-center gap-2 pt-0 pb-4">
                            <button
                                type="button"
                                className="btn btn-light px-4 py-2"
                                onClick={handleClose}
                                disabled={isLoading}
                                style={{
                                    minWidth: '140px',
                                    fontWeight: '500',
                                    border: '1px solid #dee2e6'
                                }}
                            >
                                <i className="bi bi-arrow-left me-2"></i>
                                Keep Listing
                            </button>
                            <button
                                type="button"
                                className="btn btn-danger px-4 py-2"
                                style={{
                                    opacity: isLoading === true ? 0.6 : 1,
                                    minWidth: '140px',
                                    fontWeight: '500',
                                    background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
                                    border: 'none'
                                }}
                                disabled={isLoading}
                                onClick={handleConfirm}
                            >
                                {isLoading ? (
                                    <>
                                        <ButtonSpinner />
                                        <span className="ms-2">Canceling...</span>
                                    </>
                                ) : (
                                    <>
                                        <i className="bi bi-x-circle-fill me-2"></i>
                                        Cancel Order
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <MnemonicsConfirmationModal
                visible={mnemonicsConfirmationModal}
                currentUser={currentUser}
                onClose={() => setShowMnemonicsConfirmationModal(false)}
                onConfirm={(data) => {
                    handleCancelOrder(data.mnemonics, data.publicAddress, data.saveMyMnemonics, data.mnemonicsPwd)
                    setShowMnemonicsConfirmationModal(false);
                }}
            ></MnemonicsConfirmationModal>

            <ContinueWithPassword
                visible={passwordModal}
                currentUser={currentUser}
                cypherSecret={cypherSecret}
                onClose={() => setShowPasswordModal(false)}
                onConfirm={(data) => {
                    if (data.forgotPassword) {
                        setShowPasswordModal(false)
                        setShowMnemonicsConfirmationModal(true);
                    }
                    else {
                        handleCancelOrder(data.mnemonics, data.publicAddress)
                        setShowPasswordModal(false)
                    }
                }}
            />


            <MissingMnemonics callback={(e) => handleConfirm()} />

        </>
    );
};


export default CancelOrder;



